export { Upload as default } from './Upload';
